import React from 'react'
import Product from '../Product'

function Home() {
  return (
   <>
   
   <div className="card text-bg-dark">
  <img src="https://media.architecturaldigest.com/photos/57c7003fdc03716f7c8289dd/16:9/w_1280,c_limit/IMG%20Worlds%20of%20Adventure%20-%201.jpg" className="card-img" alt="img h" height="600px" />
  <div className="card-img-overlay">
    
  </div>
</div>

<Product />
   </>
  )
}

export default Home